export default {"src":"//a.static-global.com/floxy/floxy-web-user-center-ssr/_next/static/media/correct.7c27f972.svg","height":48,"width":48};